import { ApiBase } from '../ApiBase';
class ThemeEditorApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getActiveTheme = () => {
            return this.get('/themes/active');
        };
        this.updateCheckoutSettings = (payload) => {
            return this.put('/themes/checkout', payload);
        };
    }
}
export const ThemeEditorApiClient = new ThemeEditorApiClientModel();
